<template>
  <v-alert
      class="pa-1 ma-1"
      :variant="group.reports.length > 0 ? 'outlined' : 'tonal'"
      border-color="grey accent-4"
      color="grey"
      :class="`${group.reports.length === 0 ? 'empty_report_list' : 'filled_report_list'}`"
  >
    <template v-slot:append>
      <div class="d-flex mr-1">
        <div v-if="group.reports.length === 0" class="d-flex mr-1">
          <v-btn  v-on:click="delete_group()" :icon="['fas', 'xmark']" density="compact" variant="text">
            <v-icon :icon="['fas', 'xmark']" />
          </v-btn>
          <div style="border: 1px solid grey" class="ma-1"/>
        </div>
        <div style="text-align: right; cursor: move">
          <span>Стр. {{ group.page }}</span><br>
          <LighterElement :count="group.availableSpace" />
        </div>
      </div>
    </template>
    <template v-slot:text>
      <p v-if="group.reports.length === 0">Пусто</p>
      <draggable
          class="report_list"
          :list="group.reports"
          :id="group.guid"
          v-bind="dragOptions"
          group="reports"
          @start="drag=true"
          @end="checkGroup($event)"
          item-key="id">
        <template #item="{element}">
          <EditorElement :report="element" :group_id="group.guid" :section_guid="section_guid" />
        </template>
      </draggable>
    </template>
  </v-alert>
</template>

<script>
import { ReportData } from "@/store/report/ReportData";
import EditorElement from "@/components/Reports/Editor__Tool/DragBlocks/EditorElement.vue"
import draggable from "vuedraggable"
import { Allerts } from "@/store/global/Allerts";
import LighterElement from "@/components/Reports/Editor__Tool/LighterElement.vue";


export default {
  name: "GroupElement",
  props: ['group', 'section_guid'],
  components: {LighterElement, EditorElement, draggable },
  methods: {
    getClassBySpace: function (space) {
      switch (space) {
        case 3: return 'has-space-3'
        case 2: return 'has-space-2'
        case 1: return 'has-space-1'
        case 0: return 'has-space-0'
        default: return 'has-err-space'
      }
    },
    recalculateSpace: function () {
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          let freeSpace = 3
          let usedSpace = 0
          if (group.reports.length > 0) {
            group.reports.forEach((report) => {
              let chart = this.$rep_cfg.charts.find(el => el.guid === report.report_guid)
              if (chart) {
                usedSpace += chart.needSpace
              } else {
                usedSpace = 0
              }
            })
          } else {
            usedSpace = 0
          }
          group.availableSpace = freeSpace - usedSpace
        })
      })
    },
    // Функция проверки группы (Страницы) на возможность добавления в неё графика
    checkGroup: function (ev) {
      // Объявляем хранилища для группы источника и группы назначения
      let group_from
      let group_to
      if (ev.to.id !== 'unused') {
        // Находим по ГУИД и записываем исходную группу
        for (let section of this.report_data.section_list) {
          if (section.groups.find(group => group.guid === ev.from.id)) {
            group_from = section.groups[section.groups.indexOf(section.groups.find(group => group.guid === ev.from.id))]
          }
        }
        // Находим по ГУИД и записываем группу назначения
        for (let section of this.report_data.section_list) {
          if (section.groups.find(group => group.guid === ev.to.id)) {
            group_to = section.groups[section.groups.indexOf(section.groups.find(group => group.guid === ev.to.id))]
          }
        }
        // Проверяем, есть ли на целевой странице место для графика
        // Находим, сколько места на странице занимает график
        let unique_guid = ev.clone.id
        let rp = this.report_data.data.find(el => el.unique_guid === unique_guid)

        let chart_cfg = this.$rep_cfg.charts.find(el => el.guid === rp.report_guid)
        // Сравниваем его с ещё доступным местом
        if (chart_cfg) {
          if (group_to.availableSpace === -1) {
            this.drag=false
          } else if (group_to.availableSpace >= chart_cfg.needSpace) {
            // Есть место
            this.drag=false
          } else {
            // Нехватка свободного места, обрабатываем ошибку
            Allerts().warn(
                'ОШИБКА',
                `На странице недостаточно места! Доступное место ${group_to.availableSpace}, необходимое свободное место: ${chart_cfg.needSpace}!`,
                'deep-orange',
                'triangle-exclamation'
            )
            let to_transfer = group_to.reports.find(report => {
              return report.unique_guid === unique_guid
            })
            group_from.reports.push(to_transfer)
            group_to.reports.splice(group_to.reports.indexOf(group_to.reports.find(report => report.unique_guid === to_transfer.unique_guid)), 1)
          }
        } else {
          // Ошибка, данный отчёт не найден в конфигурационном файле
          let to_transfer = group_to.reports.find(report => report.unique_guid === ev.item.id)
          group_from.reports.push(to_transfer)
          group_to.reports.splice(group_to.reports.indexOf(group_to.reports.find(report => report.unique_guid === to_transfer.unique_guid)), 1)
          Allerts().warn('ФАТАЛЬНАЯ ОШИБКА', `Ошибка внутренних типов. Отчёт не найден в конфигурационном файле!`,'black', 'triangle-exclamation')
        }
      } else {
        let to_transfer = this.report_data['unused'].find(report => {
          return report.report_guid === ev.item.id.split('_')[2]
        })
        this.report_data.unused.push(to_transfer)
        this.drag=false
      }
      this.recalculateSpace()
    },
    delete_group: function () {
      for (const report of this.group.reports) {
        this.report_data['unused'].push(report)
      }
      this.report_data.section_list.forEach((section, index) => {
        if (section.groups.map(e => e['guid']).indexOf(this.group['guid']) > -1) {
          let group_to_remove = this.report_data.section_list[index].groups.find(group => group['guid'] === this.group['guid'])
          if (group_to_remove.reports.length >= 2) {
            let indexer = this.report_data.section_list[index].groups.indexOf(group_to_remove)
            section.groups.splice(indexer, 1);
          } else if (group_to_remove.reports.length === 0) {
            let indexer = this.report_data.section_list[index].groups.indexOf(group_to_remove)
            section.groups.splice(indexer, 1);
          } else {
            group_to_remove.reports = []
          }
        }

      })
      this.recalculatePages()
      this.recalculateSpace()
    },
    recalculatePages: function () {
      console.log('Пересчитываю страницы!')
      let page = 1
      this.report_data.section_list.forEach((section) => {
        section.groups.forEach((group) => {
          group.page = page
          page++
        })
      })
      this.has_file = true
    },

  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "reports",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    report_data: {
      get() {
        return ReportData().get()
      },
      set(value) {
        ReportData().set(value)
      }
    }
  },
  data() {
    return {
      drag: false
    }
  }
}
</script>

<style scoped>
.filled_report_list {
  border-radius: 5px;
  border: 1px dotted;
}
.empty_report_list {
  border-radius: 5px;
}
.has-space-3 {
  border: 1px dotted #40c253;
}
.has-space-2 {
  border: 1px dotted #40c253;
}
.has-space-1 {
  border: 1px dotted #c2b140;
}
.has-space-0 {
  border: 1px solid #c34a4a;
}
.has-err-space {
  border: 1px double #c34a4a;
}
</style>
